(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  root.PMPriorityEligibility = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var PRIORITY_VARIANT_ID = '52531257770260';
  var PRIORITY_SKU = 'PRIORITY-PROCESSING';
  var PAB_VARIANT_IDS = {
    '52502897590548': true,
    '52674499019028': true
  };
  var PAB_ACCESSORY_VARIANT_IDS = {
    '44193409138964': true,
    '44193409171732': true,
    '44193409204500': true,
    '44193409237268': true,
    '45279612993812': true
  };
  var AUX_VENDORS = {
    're:do': true,
    'redo': true,
    'route': true,
    'extend': true,
    'allstate': true
  };
  var AUX_TYPE_EXACT = {
    service: true,
    warranty: true,
    protection: true,
    insurance: true,
    coverage: true,
    addon: true,
    'add-on': true,
    'add on': true
  };
  var AUX_PHRASES = [
    'warranty',
    'protection',
    'insurance',
    'coverage',
    'gift card',
    'gift-card',
    'giftcard',
    'gift wrap',
    'gift-wrap',
    'gift wrapping',
    'shipping protection',
    'package protection',
    'service fee',
    'service product'
  ];

  function str(value) {
    return value == null ? '' : String(value);
  }

  function lower(value) {
    return str(value).trim().toLowerCase();
  }

  function numericId(value) {
    var raw = str(value);
    if (!raw) return '';
    var match = raw.match(/(\d+)$/);
    return match ? match[1] : raw;
  }

  function attrValue(node) {
    if (node == null) return '';
    if (typeof node === 'string' || typeof node === 'number' || typeof node === 'boolean') {
      return str(node);
    }
    if (typeof node.value === 'string' || typeof node.value === 'number' || typeof node.value === 'boolean') {
      return str(node.value);
    }
    return '';
  }

  function containsPhrase(haystack, phrase) {
    return haystack.indexOf(phrase) !== -1;
  }

  function propsOf(item) {
    if (!item) return {};
    if (item.properties && typeof item.properties === 'object') return item.properties;
    if (item.attributes && typeof item.attributes === 'object' && !Array.isArray(item.attributes)) {
      return item.attributes;
    }
    return {};
  }

  function normalizeLine(item) {
    if (!item) {
      return {
        variant_id: '',
        sku: '',
        vendor: '',
        product_type: '',
        gift_card: false,
        handle: '',
        title: '',
        properties: {},
        collective: false,
        auxiliary_tag: false
      };
    }

    var merch = item.merchandise || {};
    var product = merch.product || item.product || {};
    var props = propsOf(item);
    if (!item.properties) {
      var mapped = {
        _custom_build: attrValue(item.customBuild),
        _build_id: attrValue(item.buildId),
        _unique_build: attrValue(item.uniqueBuild),
        _parent: attrValue(item.parentAttr),
        _feature: attrValue(item.featureAttr),
        _pab_accessory_line: attrValue(item.pabAccessoryLine),
        _pab_adjustment_line: attrValue(item.adjustmentLine),
        _pab_pricing_model: attrValue(item.pricingModel),
        _redo_type: attrValue(item.redoType),
        _warranty: attrValue(item.warrantyAttr),
        _protection: attrValue(item.protectionAttr),
        _service_line: attrValue(item.serviceLine),
        _gift_with_purchase: attrValue(item.giftWithPurchase),
        Tier: attrValue(item.tier),
        Stacks: attrValue(item.stacks)
      };
      Object.keys(mapped).forEach(function (key) {
        if (mapped[key]) props[key] = mapped[key];
      });
    }

    var hasAnyTag = product.hasAnyTag;
    if (typeof hasAnyTag === 'object' && hasAnyTag) {
      hasAnyTag = !!(hasAnyTag.hasTag || hasAnyTag.value);
    }

    return {
      variant_id: numericId(item.variant_id || item.variantId || merch.id || (item.variant && item.variant.id)),
      sku: str(item.sku || merch.sku),
      vendor: str(item.vendor || product.vendor),
      product_type: str(item.product_type || item.productType || product.productType),
      gift_card: item.gift_card === true || product.isGiftCard === true,
      handle: str(item.handle || product.handle || (item.product && item.product.handle)),
      title: str(item.title || item.product_title || product.title),
      properties: props,
      collective: item.collective === true || product.collective === true ||
        product.template_suffix === 'vendor-not-prop-money-inc' ||
        (Array.isArray(product.tags || item.tags) && (product.tags || item.tags).some(function (tag) {
          return lower(tag).replace(/[ _]+/g, '-') === 'shopify-collective';
        })),
      auxiliary_tag: hasAnyTag === true || item.auxiliary_tag === true
    };
  }

  function isPriority(item) {
    var line = normalizeLine(item);
    if (line.variant_id === PRIORITY_VARIANT_ID) return true;
    if (line.sku.toUpperCase() === PRIORITY_SKU) return true;
    if (line.handle.indexOf('priority-processing') !== -1) return true;
    return false;
  }

  function isPabLine(item) {
    var line = normalizeLine(item);
    if (isPriority(line)) return false;
    var props = line.properties || {};
    if (props._custom_build) return true;
    if (props.Tier && props.Stacks && props._build_id) return true;
    if (PAB_VARIANT_IDS[line.variant_id]) return true;
    if (str(props._pab_accessory_line) === 'true' && str(props._build_id).trim()) return true;
    if (str(props._build_id).trim() && PAB_ACCESSORY_VARIANT_IDS[line.variant_id]) return true;
    if (props._parent || props._feature || props._unique_build) return true;
    if (props._pab_adjustment_line || props._pab_pricing_model) return true;
    if (str(props._build_id).trim()) return true;
    return false;
  }

  function isAuxiliaryLine(item) {
    var line = normalizeLine(item);
    if (isPriority(line) || isPabLine(line)) return false;
    var props = line.properties || {};
    var vendor = lower(line.vendor);
    var sku = lower(line.sku);
    var type = lower(line.product_type);
    var handle = lower(line.handle);
    var haystack = [type, handle, vendor, sku].join(' ');

    // Digital certificate lines never qualify for Priority Processing
    // (delivered as a PDF, not through the production queue).
    if (line.variant_id === '52752838263060' || sku === 'order-certificate') return true;
    if (vendor === 're:do' || sku === 'x-redo' || props._redo_type) return true;
    if (line.gift_card) return true;
    if (line.auxiliary_tag) return true;
    if (AUX_VENDORS[vendor]) return true;
    if (AUX_TYPE_EXACT[type]) return true;
    if (
      props._warranty ||
      props._protection ||
      props._service_line ||
      props._gift_with_purchase
    ) {
      return true;
    }
    for (var i = 0; i < AUX_PHRASES.length; i += 1) {
      if (containsPhrase(haystack, AUX_PHRASES[i])) return true;
    }
    return false;
  }

  function isCollectiveLine(item) {
    return normalizeLine(item).collective;
  }

  function isRegularMerchandiseLine(item) {
    if (!item) return false;
    if (isPriority(item) || isPabLine(item) || isCollectiveLine(item) || isAuxiliaryLine(item)) return false;
    return true;
  }

  function cartItems(cart) {
    if (!cart) return [];
    if (Array.isArray(cart.items)) return cart.items;
    if (Array.isArray(cart.lines)) return cart.lines;
    return [];
  }

  function cartHasEligibleRegularMerchandise(cart) {
    return cartItems(cart).some(isRegularMerchandiseLine);
  }

  function cartEligibleForPriorityProcessing(cart) {
    return cartHasEligibleRegularMerchandise(cart);
  }

  function cartShouldShowPriorityUpsell(cart) {
    return cartEligibleForPriorityProcessing(cart);
  }

  function priorityLines(cart) {
    return cartItems(cart).filter(isPriority);
  }

  function cartHasPriority(cart) {
    return priorityLines(cart).length > 0;
  }

  function needsOrphanPriorityRemoval(cart) {
    return cartHasPriority(cart) && !cartEligibleForPriorityProcessing(cart);
  }

  function requestAddsPriority(url, bodyText, variantId) {
    var target = numericId(variantId || PRIORITY_VARIANT_ID);
    var path = lower(url);
    if (!/\/cart\/(add|update|change)\.js/.test(path)) return false;
    var raw = str(bodyText);
    if (!raw) return false;
    if (raw.indexOf(target) === -1 && raw.toUpperCase().indexOf(PRIORITY_SKU) === -1) {
      return false;
    }
    try {
      var payload = JSON.parse(raw);
      if (payload && payload.updates && Number(payload.updates[target]) > 0) return true;
      if (payload && payload.updates && Number(payload.updates[PRIORITY_VARIANT_ID]) > 0) return true;
      if (numericId(payload.id) === target && Number(payload.quantity) > 0) return true;
      var items = payload.items || (payload.item ? [payload.item] : []);
      if (!Array.isArray(items)) items = [items];
      return items.some(function (entry) {
        if (!entry) return false;
        var id = numericId(entry.id || entry.variant_id);
        return id === target && Number(entry.quantity == null ? 1 : entry.quantity) > 0;
      });
    } catch (_e) {
      return new RegExp('(?:id|updates)[=:"\\s]*' + target).test(raw) && !/quantity["\s:=]*0/.test(raw);
    }
  }

  return {
    PRIORITY_VARIANT_ID: PRIORITY_VARIANT_ID,
    PRIORITY_SKU: PRIORITY_SKU,
    normalizeLine: normalizeLine,
    isPriority: isPriority,
    isPabLine: isPabLine,
    isCollectiveLine: isCollectiveLine,
    isAuxiliaryLine: isAuxiliaryLine,
    isRegularMerchandiseLine: isRegularMerchandiseLine,
    cartHasEligibleRegularMerchandise: cartHasEligibleRegularMerchandise,
    cartEligibleForPriorityProcessing: cartEligibleForPriorityProcessing,
    cartShouldShowPriorityUpsell: cartShouldShowPriorityUpsell,
    priorityLines: priorityLines,
    cartHasPriority: cartHasPriority,
    needsOrphanPriorityRemoval: needsOrphanPriorityRemoval,
    requestAddsPriority: requestAddsPriority
  };
});

(() => {
  if (window.__PM_PRIORITY_UPSELL_INIT) return;
  window.__PM_PRIORITY_UPSELL_INIT = true;

  const VARIANT_ID = 52531257770260;
  const SKU = 'PRIORITY-PROCESSING';
  const PP_PRICE_CENTS = 599;
  // Both add-ons share one writer and one projected total. Shopify cart writes
  // are not atomic across independent scripts; a late response must not paint
  // over the buyer's newer selection in the other script.
  // Order Certificate cents are server-rendered on every cert offer card
  // (data-cert-price-cents, sourced from the live variant price).
  // Falls back to 399 when the attribute is missing or unparseable.
  function certPriceCents() {
    try {
      var box = document.querySelector('[data-cert-offer][data-cert-price-cents]');
      var cents = parseInt(box && box.getAttribute('data-cert-price-cents'), 10);
      if (isFinite(cents) && cents > 0) return cents;
    } catch (_e) {}
    return 399;
  }
  const cartOptions = window.PMCartOptionCoordinator || (window.PMCartOptionCoordinator = (() => {
    const ids = { priority: String(VARIANT_ID), cert: '52752838263060' };
    const prices = { priority: PP_PRICE_CENTS, cert: certPriceCents() };
    const desired = { priority: null, cert: null };
    let truth = null;
    let tail = Promise.resolve();
    let queued = 0;
    function has(cart, type) {
      return !!(cart && Array.isArray(cart.items) && cart.items.some((item) =>
        String(item.variant_id) === ids[type] && Number(item.quantity || 0) > 0));
    }
    function paint() {
      if (!truth || typeof truth.total_price !== 'number') return;
      let cents = truth.total_price;
      for (const type of ['priority', 'cert']) {
        if (desired[type] !== null && desired[type] !== has(truth, type)) {
          cents += desired[type] ? prices[type] : -prices[type];
        }
      }
      const text = money(Math.max(0, cents));
      document.querySelectorAll('[data-atc-banner-cart-subtotal],[data-cart-total]')
        .forEach((el) => { el.textContent = text; });
      if (document.querySelector('[data-cart-section]') &&
          typeof window.PMCartUpdateFreeShipping === 'function') {
        window.PMCartUpdateFreeShipping(Math.max(0, cents));
      }
    }
    return {
      desired(type, value) { desired[type] = !!value; paint(); },
      clear(type) { desired[type] = null; paint(); },
      accept(cart) { if (cart && Array.isArray(cart.items)) { truth = cart; paint(); } },
      busy() { return queued > 0 || desired.priority !== null || desired.cert !== null; },
      run(task) {
        queued += 1;
        const job = tail.then(task);
        tail = job.then(() => { queued -= 1; }, () => { queued -= 1; });
        return job;
      }
    };
  })());
  const SYNC_DEBOUNCE_MS = 200;
  const LOG = '[priority-processing]';

  // State machine: clicks are always accepted immediately and apply
  // optimistic UI. Server sync is debounced and coalesces multiple clicks
  // into a single /cart/update.js round-trip (`updates: { variant_id: qty }`).
  // `pendingDesired` is the most recent intent the user has expressed.
  // `syncInFlight` guards against concurrent flushes — but additional clicks
  // during a flush are absorbed into `pendingDesired` and processed by the
  // loop or scheduled immediately in the finally block.
  let syncInFlight = false;
  let pendingDesired = null;
  let syncTimer = null;
  let lastOptimisticChecked = null;
  let cleanupInFlight = false;
  let orphanRemovalTimer = null;
  let regularLineRemoveInFlight = false;
  let toggleHandlersInFlight = 0;
  let cartNavigationInFlight = false;
  const ORPHAN_REMOVAL_POLL_MS = 120;
  const ORPHAN_REMOVAL_MAX_WAIT_MS = 4000;
  const NAVIGATION_SYNC_POLL_MS = 25;
  const NAVIGATION_SYNC_MAX_WAIT_MS = 10000;

  const log = (...args) => console.log(LOG, ...args);
  const warn = (...args) => console.warn(LOG, ...args);
  const error = (...args) => console.error(LOG, ...args);

  function sanitizeMoneyFormatForUS(fmt) {
    const fallback = '${{amount}}';
    if (!fmt || typeof fmt !== 'string') return fallback;
    return fmt
      .replace(/\{\{amount_with_comma_separator\}\}/g, '{{amount}}')
      .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/g, '{{amount_no_decimals}}')
      .replace(/\{\{amount_with_apostrophe_separator\}\}/g, '{{amount}}');
  }

  function getCartMoneyFormat() {
    const el = document.querySelector('script[data-section-type="static-cart-rebuild"][data-section-data]');
    const fallback = '${{amount}}';
    if (!el) return fallback;
    try {
      const d = JSON.parse(el.textContent);
      return sanitizeMoneyFormatForUS((d.settings && d.settings.money_format) || fallback);
    } catch (_e) {
      return fallback;
    }
  }

  function fixUSMoneyDisplay(formatted) {
    if (!formatted || typeof formatted !== 'string') return formatted;
    const eu = formatted.match(/^([^\d]*)(\d{1,3}(?:\.\d{3})+)(,(\d{2}))?([^\d]*)$/);
    if (eu) {
      let euInt = eu[2].replace(/\./g, '');
      const euDec = eu[4] || '00';
      euInt = euInt.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return eu[1] + euInt + '.' + euDec + eu[5];
    }
    const us = formatted.match(/^([^\d]*)(\d+)(\.\d+)?([^\d]*)$/);
    if (us && us[2].indexOf(',') === -1 && us[2].length > 3) {
      const usInt = us[2].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return us[1] + usInt + (us[3] || '') + us[4];
    }
    return formatted;
  }

  function money(cents) {
    const safe = Number(cents) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return fixUSMoneyDisplay(window.Shopify.formatMoney(safe, getCartMoneyFormat()));
    }
    const dollars = (safe / 100).toFixed(2);
    const parts = dollars.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `$${parts.join('.')}`;
  }

  const nativeFetch = window.fetch.bind(window);

  const priorityProductCache = new Map();
  const priorityProductLoads = new Map();

  async function hydratePriorityProducts(cart) {
    document.querySelectorAll('[data-priority-product-metadata]').forEach((node) => {
      try {
        JSON.parse(node.textContent).forEach((product) => {
          if (product.handle && !priorityProductCache.has(product.handle)) {
            priorityProductCache.set(product.handle, product);
          }
        });
      } catch (_error) {}
    });
    await Promise.all((cart.items || []).map(async (item) => {
      if (window.PMPriorityEligibility.isPriority(item) ||
          window.PMPriorityEligibility.isPabLine(item) ||
          window.PMPriorityEligibility.isAuxiliaryLine(item)) return;
      const handle = item.handle || (item.url || '').match(/\/products\/([^?/#]+)/)?.[1];
      if (!handle) throw new Error('Cannot verify Priority Processing product eligibility');
      if (!priorityProductCache.has(handle)) {
        if (!priorityProductLoads.has(handle)) {
          const routeRoot = window.Shopify?.routes?.root || '/';
          priorityProductLoads.set(handle, nativeFetch(routeRoot + 'products/' + encodeURIComponent(handle) + '.js', {
            credentials: 'same-origin', cache: 'no-store'
          }).then(async (response) => {
            if (!response.ok) throw new Error('Cannot verify Priority Processing product eligibility');
            const product = await response.json();
            if (!Array.isArray(product.tags)) throw new Error('Missing product eligibility metadata');
            priorityProductCache.set(handle, product);
          }).finally(() => priorityProductLoads.delete(handle)));
        }
        await priorityProductLoads.get(handle);
      }
      const product = priorityProductCache.get(handle);
      item.collective = window.PMPriorityEligibility.isCollectiveLine({ product });
    }));
    return cart;
  }

  async function fetchCart() {
    const res = await nativeFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!res.ok) throw new Error(`cart.js failed (${res.status})`);
    return hydratePriorityProducts(await res.json());
  }

  function isPriority(item) {
    if (!item) return false;
    if (String(item.variant_id) === String(VARIANT_ID)) return true;
    if (item.sku && String(item.sku).toUpperCase() === SKU) return true;
    return false;
  }

  const Eligibility = window.PMPriorityEligibility || {};

  function isPabLine(item) {
    if (typeof Eligibility.isPabLine === 'function') return Eligibility.isPabLine(item);
    return false;
  }

  function cartShouldShowPriorityUpsell(cart) {
    if (typeof Eligibility.cartShouldShowPriorityUpsell === 'function') {
      return Eligibility.cartShouldShowPriorityUpsell(cart);
    }
    return false;
  }

  function cartEligibleForPriorityProcessing(cart) {
    if (typeof Eligibility.cartEligibleForPriorityProcessing === 'function') {
      return Eligibility.cartEligibleForPriorityProcessing(cart);
    }
    return cartShouldShowPriorityUpsell(cart);
  }

  function priorityLines(cart) {
    const items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.filter(isPriority);
  }

  function cartHasPriority(cart) {
    return priorityLines(cart).length > 0;
  }

  function syncPabPriorityNotices(cartOrChecked) {
    let show = false;
    if (typeof cartOrChecked === 'boolean') {
      show = cartOrChecked;
    } else if (cartOrChecked && Array.isArray(cartOrChecked.items)) {
      show = cartHasPriority(cartOrChecked);
    } else {
      show = !!document.querySelector('[data-priority-processing-toggle]:checked');
    }
    document.querySelectorAll('[data-cart-item-pab-notice]').forEach((el) => {
      el.hidden = !show;
    });
  }

  function syncAtcUpsellView(cart) {
    const hasPriority = cartHasPriority(cart);
    document.querySelectorAll('[data-priority-atc-confirm]').forEach((el) => {
      el.hidden = !hasPriority;
    });
    document.querySelectorAll('[data-priority-atc-offer]').forEach((el) => {
      el.hidden = hasPriority;
    });
  }

  function optimisticAtcSwap(checked) {
    document.querySelectorAll('[data-priority-atc-confirm]').forEach((el) => {
      el.hidden = !checked;
    });
    document.querySelectorAll('[data-priority-atc-offer]').forEach((el) => {
      el.hidden = !!checked;
    });
  }

  function parseMoneyToCents(text) {
    if (!text) return null;
    const raw = String(text).trim();
    const eu = raw.match(/^[^\d]*(\d{1,3}(?:\.\d{3})*),(\d{2})[^\d]*$/);
    if (eu) {
      const intPart = eu[1].replace(/\./g, '');
      const dollars = parseFloat(intPart + '.' + eu[2]);
      if (!isFinite(dollars)) return null;
      return Math.round(dollars * 100);
    }
    const cleaned = raw.replace(/[^\d.,-]/g, '').replace(/,/g, '');
    if (!cleaned) return null;
    const dollars = parseFloat(cleaned);
    if (!isFinite(dollars)) return null;
    return Math.round(dollars * 100);
  }

  function optimisticSubtotalAdjust(deltaCents) {
    document.querySelectorAll('[data-atc-banner-cart-subtotal]').forEach((el) => {
      const cents = parseMoneyToCents(el.textContent || '');
      if (cents != null) {
        el.textContent = money(Math.max(0, cents + deltaCents));
      }
    });
    document.querySelectorAll('[data-cart-total]').forEach((el) => {
      const cents = parseMoneyToCents(el.textContent || '');
      if (cents != null) {
        el.textContent = money(Math.max(0, cents + deltaCents));
      }
    });
  }

  function applyOptimisticState(checked) {
    optimisticAtcSwap(checked);
    syncPabPriorityNotices(checked);
    if (lastOptimisticChecked === null) {
      // First interaction — initialize tracker without an unsubstantiated
      // subtotal delta (we don't know the prior state for sure).
      lastOptimisticChecked = checked;
      return;
    }
    if (lastOptimisticChecked !== checked) {
      optimisticSubtotalAdjust(checked ? PP_PRICE_CENTS : -PP_PRICE_CENTS);
      lastOptimisticChecked = checked;
    }
  }

  function setToggles(checked, disabled) {
    document.querySelectorAll('[data-priority-processing-toggle]').forEach((el) => {
      el.checked = !!checked;
      el.disabled = !!disabled;
      el.setAttribute('aria-busy', disabled ? 'true' : 'false');
      el.setAttribute('data-priority-processing-bound', 'true');
    });
    syncPabPriorityNotices(!!checked);
  }

  function markRows(cart) {
    const keys = new Set(priorityLines(cart).map((i) => String(i.key || '')));
    document.querySelectorAll('li[data-cartitem], tr.cart-item').forEach((row) => {
      const key = String(row.getAttribute('data-cartitem-key') || '');
      if (keys.has(key)) row.setAttribute('data-priority-processing-line', 'true');
      else row.removeAttribute('data-priority-processing-line');
    });
  }

  function syncPriorityProcessingCartCents(cart) {
    const ppTotal = priorityLines(cart).reduce((sum, line) => sum + Number(line.final_line_price || 0), 0);
    if (window.PMCartPriorityProcessing && typeof window.PMCartPriorityProcessing.setCartCents === 'function') {
      window.PMCartPriorityProcessing.setCartCents(ppTotal);
    }
  }

  function needsOrphanPriorityRemoval(cart) {
    if (typeof Eligibility.needsOrphanPriorityRemoval === 'function') {
      return Eligibility.needsOrphanPriorityRemoval(cart);
    }
    return !!(cart && priorityLines(cart).length > 0 && !cartEligibleForPriorityProcessing(cart));
  }

  function hasPendingCartLineRemoval() {
    return !!document.querySelector(
      '.cartitems--list [data-cartitem-id].removing, .cartitems--list [data-cartitem].removing'
    );
  }

  function cancelDeferredOrphanRemoval() {
    if (!orphanRemovalTimer) return;
    clearTimeout(orphanRemovalTimer);
    orphanRemovalTimer = null;
  }

  // Empire dispatches cartcount:update before morphdom rewrites the list.
  // Running orphan PP removal in that window races the line removal and can
  // abort morphdom, leaving the regular product visible while PP turns off.
  function scheduleDeferredOrphanRemoval() {
    cancelDeferredOrphanRemoval();
    const startedAt = Date.now();

    const attempt = () => {
      orphanRemovalTimer = null;
      if (syncInFlight || pendingDesired !== null) return;
      if (cleanupInFlight) {
        orphanRemovalTimer = setTimeout(attempt, ORPHAN_REMOVAL_POLL_MS);
        return;
      }
      if (hasPendingCartLineRemoval() && Date.now() - startedAt < ORPHAN_REMOVAL_MAX_WAIT_MS) {
        orphanRemovalTimer = setTimeout(attempt, ORPHAN_REMOVAL_POLL_MS);
        return;
      }
      syncPriorityProcessingStateFromCart(null, { orphanRemovalOnly: true });
    };

    orphanRemovalTimer = setTimeout(attempt, ORPHAN_REMOVAL_POLL_MS);
  }

  function applyOptimisticOrphanRemoval(cart) {
    if (!needsOrphanPriorityRemoval(cart)) return false;

    const ppLines = priorityLines(cart);
    const removedKeys = ppLines.map((line) => line.key).filter(Boolean);
    const ppCents = ppLines.reduce(
      (sum, line) => sum + Number(line.final_line_price || PP_PRICE_CENTS),
      0
    );

    removePriorityLineItemsFromDom(removedKeys);
    syncPriorityProcessingCartCents({ items: [] });
    setToggles(false, false);
    syncAtcUpsellView({ items: (cart.items || []).filter((item) => !isPriority(item)) });
    syncUpsellSurfaceVisibility(cart);
    lastOptimisticChecked = false;

    if (typeof window.updateCartTotals === 'function' && document.querySelector('[data-cart-section]')) {
      const projectedItems = (cart.items || []).filter((item) => !isPriority(item));
      const projectedCart = { items: projectedItems, total_price: cart.total_price - ppCents };
      try {
        window.updateCartTotals(projectedCart);
      } catch (_e) {
        optimisticSubtotalAdjust(-ppCents);
      }
      if (typeof window.PMCartUpdateFreeShipping === 'function') {
        window.PMCartUpdateFreeShipping(projectedCart.total_price);
        document.querySelectorAll('[data-cart-total-cents]').forEach((el) => {
          el.setAttribute('data-cart-total-cents', String(projectedCart.total_price));
        });
      }
    } else {
      optimisticSubtotalAdjust(-ppCents);
    }

    return true;
  }

  function refreshVisibleTotals(cart) {
    if (!cart) return;
    cartOptions.accept(cart);
    syncPriorityProcessingCartCents(cart);
    document.querySelectorAll('[data-atc-banner-cart-subtotal]').forEach((el) => {
      el.textContent = money(cart.total_price);
    });
    document.querySelectorAll('[data-atc-banner-cart-button]').forEach((btn) => {
      btn.textContent = 'View Cart & Checkout';
    });
    if (typeof window.updateCartTotals === 'function' && document.querySelector('[data-cart-section]')) {
      try {
        window.updateCartTotals(cart);
      } catch (_e) {
        document.querySelectorAll('[data-cart-total]').forEach((el) => {
          el.textContent = money(cart.total_price);
        });
      }
      if (typeof window.PMCartUpdateFreeShipping === 'function') {
        window.PMCartUpdateFreeShipping(cart.total_price);
      }
      document.querySelectorAll('[data-cart-total-cents]').forEach((el) => {
        el.setAttribute('data-cart-total-cents', String(cart.total_price));
      });
      cartOptions.accept(cart);
      return;
    }
    if (
      typeof window.PMCartRefreshSubtotal === 'function' &&
      document.querySelector('[data-cart-section]')
    ) {
      window.PMCartRefreshSubtotal();
      cartOptions.accept(cart);
      return;
    }
    document.querySelectorAll('[data-cart-total]').forEach((el) => {
      el.textContent = money(cart.total_price);
    });
    cartOptions.accept(cart);
  }

  function syncUpsellSurfaceVisibility(cart) {
    const show = cartShouldShowPriorityUpsell(cart);
    document.querySelectorAll('[data-priority-processing-upsell]').forEach((el) => {
      el.hidden = !show;
      const hasPab = (cart.items || []).some(isPabLine);
      const hasCollective = (cart.items || []).some(Eligibility.isCollectiveLine);
      const exclusion = el.querySelector('.pm-priority-card__exclusion');
      if (exclusion) {
        exclusion.hidden = !hasPab && !hasCollective;
        exclusion.textContent = el.getAttribute(hasPab && hasCollective ? 'data-exclusion-both' :
          hasCollective ? 'data-exclusion-collective' : 'data-exclusion-pab') || '';
      }
    });
  }

  function removePriorityLineItemsFromDom(keys) {
    (keys || []).forEach((key) => {
      const safeKey = String(key || '');
      if (!safeKey) return;
      document.querySelectorAll(`[data-cartitem-key="${safeKey}"]`).forEach((node) => {
        const row =
          node.closest('li[data-cartitem], tr.cart-item, [data-cartitem-id], .cart-item') || node;
        if (row && row.parentNode) row.parentNode.removeChild(row);
      });
    });
  }

  function refreshCartUiAfterOrphanRemoval(cart) {
    if (typeof window.updateCartTotals === 'function') {
      try {
        window.updateCartTotals(cart);
      } catch (_e) {
        refreshVisibleTotals(cart);
      }
    } else {
      refreshVisibleTotals(cart);
    }
    syncUpsellSurfaceVisibility(cart);
  }

  async function removeOrphanedPriorityProcessing(cart, options) {
    const opts = options || {};
    const skipOptimistic = !!opts.skipOptimistic;
    const ppLines = priorityLines(cart);
    if (!ppLines.length) return { cart, removed: false, removedKeys: [] };
    if (!needsOrphanPriorityRemoval(cart)) return { cart, removed: false, removedKeys: [] };

    const removedKeys = ppLines.map((line) => line.key).filter(Boolean);
    log('Removing orphaned Priority Processing — cart has no eligible regular merchandise', {
      keys: removedKeys,
      skipOptimistic,
    });

    if (!skipOptimistic) {
      applyOptimisticOrphanRemoval(cart);
    }

    let freshCart = cart;
    for (let i = 0; i < removedKeys.length; i += 1) {
      freshCart = await changeLineByKey(removedKeys[i], 0);
    }
    if (!skipOptimistic) {
      removePriorityLineItemsFromDom(removedKeys);
    }
    return { cart: freshCart, removed: true, removedKeys };
  }

  // Single-call set-quantity endpoint. `/cart/update.js` returns the full
  // cart so we don't need a separate `/cart.js` fetch for reconciliation.
  async function setPriorityQuantity(quantity) {
    if (Number(quantity) > 0) {
      const cart = await fetchCart();
      if (!cartEligibleForPriorityProcessing(cart)) {
        warn('Refusing Priority Processing add — cart has no eligible regular merchandise');
        return cart;
      }
    }
    const res = await nativeFetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: { [VARIANT_ID]: quantity } }),
    });
    if (!res.ok) {
      const body = await res.text().catch(() => '');
      error('PP qty update failed', { status: res.status, body, quantity });
      throw new Error(`update.js failed (${res.status})`);
    }
    return hydratePriorityProducts(await res.json());
  }

  async function changeLineByKey(key, quantity) {
    const res = await nativeFetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!res.ok) {
      const body = await res.text().catch(() => '');
      error('Remove/change request failed', { status: res.status, body, key, quantity });
      throw new Error(`change.js failed (${res.status})`);
    }
    return hydratePriorityProducts(await res.json());
  }

  async function setLineQuantityByLine(line, quantity) {
    return nativeFetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
  }

  async function dedupeAndNormalize(cart) {
    const lines = priorityLines(cart);
    if (!lines.length) return false;

    let changed = false;

    if (lines.length > 1) {
      const extras = lines.slice(1);
      await Promise.all(extras.map((line) => changeLineByKey(line.key, 0)));
      changed = true;
    }

    const first = lines[0];
    if (Number(first.quantity) !== 1) {
      const idx = (cart.items || []).findIndex((i) => String(i.key || '') === String(first.key || ''));
      if (idx >= 0) {
        await setLineQuantityByLine(idx + 1, 1);
        changed = true;
      }
    }
    return changed;
  }

  function publishCartUpdate(cart) {
    try {
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'priority-processing-upsell',
          cartData: cart,
          variantId: String(VARIANT_ID),
        });
      }
    } catch (e) {
      warn('Cart pub/sub notify failed', e);
    }
  }

  function scheduleServerSync(checked) {
    pendingDesired = checked;
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(() => {
      syncTimer = null;
      runServerSync();
    }, SYNC_DEBOUNCE_MS);
  }

  function prioritySyncIsPending() {
    return (
      toggleHandlersInFlight > 0 ||
      !!syncTimer ||
      syncInFlight ||
      pendingDesired !== null
    );
  }

  function flushScheduledServerSync() {
    if (syncTimer) {
      clearTimeout(syncTimer);
      syncTimer = null;
    }
    if (pendingDesired !== null && !syncInFlight) {
      runServerSync();
    }
  }

  async function waitForPrioritySyncBeforeNavigation() {
    const startedAt = Date.now();
    flushScheduledServerSync();

    while (prioritySyncIsPending()) {
      if (Date.now() - startedAt >= NAVIGATION_SYNC_MAX_WAIT_MS) {
        warn('Timed out waiting for Priority Processing before cart navigation');
        return;
      }
      await new Promise((resolve) => setTimeout(resolve, NAVIGATION_SYNC_POLL_MS));
      flushScheduledServerSync();
    }
  }

  window.PMCartWaitForPriority = async function () {
    await waitForPrioritySyncBeforeNavigation();
    if (prioritySyncIsPending()) throw new Error('Priority Processing is still updating. Please try again.');
  };

  async function runServerSync() {
    if (syncInFlight) return; // pending intent will be picked up by the running loop
    syncInFlight = true;

    let lastCart = null;
    try {
      // Coalesce: drain the latest intent until no more clicks are pending.
      // Rapid on/off/on clicks collapse into a single final request unless
      // the user is still clicking faster than the network round-trip.
      while (pendingDesired !== null) {
        const target = pendingDesired;
        pendingDesired = null;
        lastCart = await cartOptions.run(() => setPriorityQuantity(target ? 1 : 0));
        cartOptions.accept(lastCart);
      }

      if (lastCart) {
        setToggles(cartHasPriority(lastCart), false);
        syncAtcUpsellView(lastCart);
        markRows(lastCart);
        refreshVisibleTotals(lastCart);
        cartOptions.accept(lastCart);
        lastOptimisticChecked = cartHasPriority(lastCart);
        publishCartUpdate(lastCart);
      }
      if (pendingDesired === null) cartOptions.clear('priority');
    } catch (e) {
      error('Server sync failed', e);
      // Hard-reconcile from server on failure.
      syncInFlight = false;
      const settled = await syncPriorityProcessingStateFromCart(null, { force: true });
      cartOptions.accept(settled);
      cartOptions.clear('priority');
      if (pendingDesired !== null) runServerSync();
      return;
    } finally {
      syncInFlight = false;
    }

    if (pendingDesired !== null) {
      // User clicked while we were reconciling — flush immediately.
      runServerSync();
    }
  }

  async function syncPriorityProcessingStateFromCart(providedCart, options) {
    const opts = options || {};
    const skipOrphanRemoval = !!opts.skipOrphanRemoval;
    const orphanRemovalOnly = !!opts.orphanRemovalOnly;

    if (orphanRemovalOnly) {
      if (cleanupInFlight || syncInFlight || pendingDesired !== null || cartOptions.busy()) return null;
      try {
        cleanupInFlight = true;
        let cart =
          providedCart && Array.isArray(providedCart.items) ? await hydratePriorityProducts(providedCart) : await fetchCart();
        if (!needsOrphanPriorityRemoval(cart)) return cart;

        const orphanResult = await removeOrphanedPriorityProcessing(cart);
        cart = orphanResult.cart;
        if (orphanResult.removed) {
          setToggles(false, false);
          syncAtcUpsellView(cart);
          syncUpsellSurfaceVisibility(cart);
          markRows(cart);
          refreshCartUiAfterOrphanRemoval(cart);
          lastOptimisticChecked = false;
          publishCartUpdate(cart);
        }
        log('Deferred orphan Priority Processing removal', {
          removed: orphanResult.removed,
          item_count: cart.item_count,
        });
        return cart;
      } catch (e) {
        error('Deferred orphan removal failed', e);
        return null;
      } finally {
        cleanupInFlight = false;
      }
    }

    if (cleanupInFlight || (cartOptions.busy() && !opts.force)) return null;
    try {
      let cart =
        providedCart && Array.isArray(providedCart.items) ? await hydratePriorityProducts(providedCart) : await fetchCart();
      let orphanResult = { cart, removed: false, removedKeys: [] };
      if (!skipOrphanRemoval) {
        orphanResult = await removeOrphanedPriorityProcessing(cart);
        cart = orphanResult.cart;
      }

      const changed = await dedupeAndNormalize(cart);
      if (changed) cart = await fetchCart();
      if (cartOptions.busy() && !opts.force) return cart;

      setToggles(cartHasPriority(cart), syncInFlight);
      syncAtcUpsellView(cart);
      syncUpsellSurfaceVisibility(cart);
      syncPabPriorityNotices(cart);
      markRows(cart);
      refreshVisibleTotals(cart);
      lastOptimisticChecked = cartHasPriority(cart);

      if (orphanResult.removed) {
        cleanupInFlight = true;
        refreshCartUiAfterOrphanRemoval(cart);
        publishCartUpdate(cart);
        cleanupInFlight = false;
      }

      log('Cart data after update', {
        item_count: cart.item_count,
        total_price: cart.total_price,
        priority_lines: priorityLines(cart).map((i) => ({ key: i.key, qty: i.quantity })),
        show_upsell: cartShouldShowPriorityUpsell(cart),
        skip_orphan_removal: skipOrphanRemoval,
      });
      return cart;
    } catch (e) {
      cleanupInFlight = false;
      syncUpsellSurfaceVisibility({ items: [] });
      error('Sync failed', e);
      if (!syncInFlight) setToggles(false, false);
      return null;
    }
  }

  function isRegularRemovableCartLine(row) {
    if (!row) return false;
    if (row.hasAttribute('data-pab-line')) return false;
    if (row.classList.contains('pab-card')) return false;
    if (row.classList.contains('cart-item--pab-classic')) return false;
    if (row.hasAttribute('data-priority-processing-line')) return false;
    if (row.classList.contains('cart-item-parent')) return false;
    if (row.classList.contains('cart-item-child')) return false;
    return row.hasAttribute('data-cartitem');
  }

  function reloadCartPage() {
    if (typeof window.pmSmoothCartReload === 'function') {
      window.pmSmoothCartReload();
      return;
    }
    window.location.reload();
  }

  function regularLineProperties(properties) {
    return JSON.stringify(Object.entries(properties || {}).sort(([a], [b]) => a.localeCompare(b)));
  }

  function resolveRegularCartLine(cart, lineKey, row) {
    const exact = cart.items.find((item) => item.key === lineKey);
    if (exact) return exact;
    if (!row || !row.hasAttribute('data-cartitem-properties')) return null;
    let properties;
    try {
      properties = JSON.parse(row.getAttribute('data-cartitem-properties'));
    } catch (_e) {
      return null;
    }
    const variantId = row.getAttribute('data-cartitem-id');
    const sellingPlan = row.getAttribute('data-cartitem-selling-plan') || '';
    const matches = cart.items.filter((item) => {
      const plan = item.selling_plan_allocation?.selling_plan?.id || '';
      return String(item.variant_id) === variantId &&
        String(plan) === sellingPlan &&
        regularLineProperties(item.properties) === regularLineProperties(properties);
    });
    return matches.length === 1 ? matches[0] : null;
  }

  function showRegularRemoveError(row, message) {
    if (!row) return;
    let notice = row.querySelector('[data-cart-remove-error]');
    if (!notice) {
      notice = document.createElement('p');
      notice.setAttribute('data-cart-remove-error', '');
      notice.setAttribute('role', 'alert');
      notice.style.cssText = 'margin:12px 0 0;font-size:13px;line-height:1.4;color:#b42318;';
      row.appendChild(notice);
    }
    notice.textContent = message;
  }

  async function removeRegularCartLine(lineKey, row) {
    if (!lineKey || regularLineRemoveInFlight) return;
    if (window.PMRegularStaged && window.PMRegularStaged.isSaving()) {
      showRegularRemoveError(row, 'Your quantity is still saving. Please try again in a moment.');
      return;
    }
    regularLineRemoveInFlight = true;
    cancelDeferredOrphanRemoval();
    const previousError = row && row.querySelector('[data-cart-remove-error]');
    if (previousError) previousError.remove();
    if (row) {
      row.classList.add('removing');
      row.setAttribute('aria-busy', 'true');
    }
    document.documentElement.classList.add('pm-cart-reloading');

    let cart;
    try {
      await waitForPrioritySyncBeforeNavigation();
      if (prioritySyncIsPending()) throw new Error('Priority Processing is still updating. Please try again.');
      cart = await fetchCart();
      const target = resolveRegularCartLine(cart, lineKey, row);
      if (!target) throw new Error('Your cart has changed. Refresh the page and try again.');
      setToggles(cartHasPriority(cart), true);

      const updates = { [target.key]: 0 };
      const remainingCart = { ...cart, items: cart.items.filter((item) => item.key !== target.key) };
      if (needsOrphanPriorityRemoval(remainingCart)) {
        priorityLines(cart).forEach((item) => { updates[item.key] = 0; });
      }
      const res = await nativeFetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!res.ok) throw new Error('We couldn’t remove this item. Please try again.');
      cart = await res.json();
      if (cart.items.some((item) => item.key === target.key)) {
        throw new Error('Your cart has changed. Refresh the page and try again.');
      }
      log('Regular cart line removed', {
        lineKey: target.key,
        item_count: cart.item_count,
        priority_remaining: cartHasPriority(cart),
      });
      reloadCartPage();
    } catch (e) {
      regularLineRemoveInFlight = false;
      if (row) {
        row.classList.remove('removing');
        row.removeAttribute('aria-busy');
      }
      document.documentElement.classList.remove('pm-cart-reloading');
      setToggles(cart ? cartHasPriority(cart) : !!lastOptimisticChecked, false);
      showRegularRemoveError(row, e.message || 'We couldn’t remove this item. Please try again.');
      error('Regular cart line remove failed', e);
    }
  }

  function onRegularCartLineRemoveClick(event) {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const removeLink = target.closest('[data-cartitem-remove]');
    if (!removeLink) return;

    const row = removeLink.closest('li[data-cartitem]');
    if (!isRegularRemovableCartLine(row)) return;

    const lineKey = row.getAttribute('data-cartitem-key') || (row.dataset && row.dataset.cartitemKey);
    if (!lineKey) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    log('Regular cart line remove intercepted — using line key instead of stale ?line= href', {
      lineKey,
    });
    removeRegularCartLine(lineKey, row);
  }

  function handleToggle(input, checked) {
    if (!input) return;
    cartOptions.desired('priority', checked);
    setToggles(checked, false);
    optimisticAtcSwap(checked);
    syncPabPriorityNotices(checked);
    lastOptimisticChecked = checked;
    scheduleServerSync(checked);
  }

  function onToggleChange(event) {
    const input = event.target;
    if (!input || !input.matches || !input.matches('[data-priority-processing-toggle]')) return;
    if (regularLineRemoveInFlight || (window.PMRegularStaged && window.PMRegularStaged.isSaving())) {
      input.checked = !!lastOptimisticChecked;
      return;
    }
    handleToggle(input, !!input.checked);
  }

  async function onAtcCartNavigation(event) {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const link = target.closest('a[data-atc-banner-cart-button]');
    if (!link) return;
    if (!prioritySyncIsPending() && !cartNavigationInFlight) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    if (cartNavigationInFlight) return;

    cartNavigationInFlight = true;
    link.setAttribute('aria-busy', 'true');
    try {
      await waitForPrioritySyncBeforeNavigation();
    } finally {
      window.location.assign(link.href);
    }
  }

  function handleAtcRemoveClick(button) {
    if (!button) return;
    log('ATC confirm checkmark clicked — removing Priority Processing');
    setToggles(false, false);
    applyOptimisticState(false);
    scheduleServerSync(false);
  }

  function onAtcRemoveClick(event) {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const trigger = target.closest('[data-priority-atc-remove]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    handleAtcRemoveClick(trigger);
  }

  function onAtcRemoveKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest('[data-priority-atc-remove]');
    if (!trigger || !trigger.matches('[data-priority-atc-confirm]')) return;
    event.preventDefault();
    handleAtcRemoveClick(trigger);
  }

  function onCartSectionRefreshed(event) {
    if (cartOptions.busy()) return;
    if (syncInFlight || pendingDesired !== null || cleanupInFlight || regularLineRemoveInFlight) return;
    if (event && event.detail && event.detail.source === 'priority-processing-upsell') return;
    syncPriorityProcessingStateFromCart();
  }

  function onCartUpdate(event) {
    if (cartOptions.busy()) return;
    if (syncInFlight || pendingDesired !== null || cleanupInFlight || regularLineRemoveInFlight) return;
    if (event && event.source === 'priority-processing-upsell') return;
    const cartSnapshot =
      event && event.cartData && Array.isArray(event.cartData.items) ? event.cartData : null;
    if (hasPendingCartLineRemoval()) {
      syncPriorityProcessingStateFromCart(cartSnapshot, { skipOrphanRemoval: true });
      scheduleDeferredOrphanRemoval();
      return;
    }
    syncPriorityProcessingStateFromCart(cartSnapshot);
  }

  function onCartCountUpdate(event) {
    if (cartOptions.busy()) return;
    if (syncInFlight || pendingDesired !== null || cleanupInFlight || regularLineRemoveInFlight) return;
    const cart = event && event.detail;
    const cartSnapshot = cart && Array.isArray(cart.items) ? cart : null;
    // Empire dispatches cartcount:update before morphdom rewrites the list.
    // Sync toggles/totals now, but defer orphan PP removal until morphdom
    // finishes so we don't race the regular-product X removal.
    queueMicrotask(() => {
      syncPriorityProcessingStateFromCart(cartSnapshot, { skipOrphanRemoval: true }).then((resolvedCart) => {
        if (needsOrphanPriorityRemoval(resolvedCart)) scheduleDeferredOrphanRemoval();
      });
    });
  }

  document.addEventListener('change', onToggleChange, true);
  document.addEventListener('click', onAtcCartNavigation, true);
  document.addEventListener('click', onAtcRemoveClick, true);
  document.addEventListener('keydown', onAtcRemoveKeydown, true);
  document.addEventListener('click', onRegularCartLineRemoveClick, true);
  document.addEventListener('cart:section-refreshed', onCartSectionRefreshed);
  window.addEventListener('cartcount:update', onCartCountUpdate);
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    if (syncInFlight || pendingDesired !== null || cleanupInFlight || regularLineRemoveInFlight) return;
    syncPriorityProcessingStateFromCart();
  });
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }

  const INELIGIBLE_MESSAGE =
    'Priority Processing is only available with eligible regular products.';

  function jsonResponse(status, payload) {
    return new Response(JSON.stringify(payload), {
      status,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  function installCartWriteGuard() {
    if (window.__PM_PRIORITY_CART_GUARD__) return;
    window.__PM_PRIORITY_CART_GUARD__ = true;

    window.fetch = async function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      const body = init && typeof init.body === 'string' ? init.body : '';
      const isCartWrite = /\/cart\/(add|update|change)\.js/i.test(url) && method !== 'GET';
      if (
        isCartWrite &&
        typeof Eligibility.requestAddsPriority === 'function' &&
        Eligibility.requestAddsPriority(url, body, VARIANT_ID)
      ) {
        try {
          const cart = await fetchCart();
          if (!cartEligibleForPriorityProcessing(cart)) {
            warn('Blocked Priority Processing cart write — no eligible regular merchandise');
            return jsonResponse(422, {
              status: 422,
              description: INELIGIBLE_MESSAGE,
              message: INELIGIBLE_MESSAGE,
            });
          }
        } catch (_e) {
          return jsonResponse(422, {
            status: 422,
            description: INELIGIBLE_MESSAGE,
            message: INELIGIBLE_MESSAGE,
          });
        }
      }

      const res = await nativeFetch(input, init);
      if (isCartWrite && res.ok) {
        try {
          const cart = await hydratePriorityProducts(await res.clone().json());
          if (needsOrphanPriorityRemoval(cart)) {
            const cleaned = await removeOrphanedPriorityProcessing(cart, { skipOptimistic: true });
            return jsonResponse(200, cleaned.cart || cart);
          }
        } catch (_e) {}
      }
      return res;
    };
  }

  async function boot() {
    installCartWriteGuard();
    await syncPriorityProcessingStateFromCart();
    if (lastOptimisticChecked === null) {
      const input = document.querySelector('[data-priority-processing-toggle]');
      lastOptimisticChecked = !!(input && input.checked);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

